export const publicRoutes = [
  '/login',
  '/forgot-password',
  '/activate-account',
  '/pricing-plans',
  '/logout',
  '/change-password',
  '/forgot-code',
  '/signup-link',
  '/embed',
  '/my-virtual-humans/embed/',
  { path: '/register', exact: true },
];

export const helpExceptions = ['/login', '/forgot-password', '/activate-account'];
